export default "__VITE_ASSET__U9xMX1zy__"